import { Preview } from "../../../types/IAction";
import * as actions from "../../actions/externoDetalle";
import { GetExternosDetalle } from "../../reducers/externoDetalle";

export interface ExternosListDispatcher {
  getExternosDetalleByFilters: (
    filters: any
  ) => Promise<Preview<GetExternosDetalle>>;
  getExternosDetalleByIdPersona: (
    idPersona: number,
    params?: any
  ) => Promise<Preview<GetExternosDetalle>>;
  getExternosDetalleByCurp: (
    curp: string,
    params?: any
  ) => Promise<Preview<GetExternosDetalle>>;
}

export const externosListDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ExternosListDispatcher = dispatch => ({
  getExternosDetalleByFilters: (filters: any) =>
    dispatch(actions.getExternosDetalleByFilters(filters)),
  getExternosDetalleByIdPersona: (idPersona: number, params?: any) =>
    dispatch(actions.getExternosDetalleByIdPersona(idPersona, params)),
  getExternosDetalleByCurp: (curp: string, params?: any) =>
    dispatch(actions.getExternosDetalleByCurp(curp, params))
});
